var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{staticClass:"ml-5",attrs:{"color":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.$router.go(-1)}}},[_vm._v(" "+_vm._s(_vm.icons.mdiArrowLeft)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }